var map = {
	"./007-microphone-1.png": 608,
	"./010-home.png": 609,
	"./013-document-1.png": 610,
	"./014-document.png": 611,
	"./015-color-palette.png": 612,
	"./017-video-camera.png": 613,
	"./024-like.svg": 614,
	"./1.svg": 615,
	"./155-credit-card.svg": 616,
	"./2.svg": 617,
	"./3.svg": 618,
	"./4.svg": 619,
	"./New Customer.svg": 620,
	"./NotOpen.svg": 621,
	"./Opened.svg": 622,
	"./Profit.svg": 623,
	"./SalesRevenue.svg": 624,
	"./Sent.svg": 625,
	"./Slack.svg": 626,
	"./address.svg": 627,
	"./adobe.svg": 628,
	"./arrow-left.svg": 629,
	"./arrow-right.svg": 630,
	"./birlesik-logo.png": 357,
	"./book.svg": 631,
	"./camera.svg": 632,
	"./chat.svg": 633,
	"./clipboard.svg": 634,
	"./cloud.svg": 635,
	"./columns.svg": 636,
	"./documentation.svg": 637,
	"./file.svg": 638,
	"./flat.svg": 639,
	"./headphone.svg": 640,
	"./iconfinder_trello_2317760.svg": 641,
	"./idea.svg": 642,
	"./image.png": 643,
	"./image.svg": 644,
	"./label.png": 645,
	"./layers.svg": 646,
	"./left.svg": 647,
	"./logo2.svg": 648,
	"./logo3.svg": 649,
	"./logo4.svg": 650,
	"./logo5.svg": 651,
	"./logo6.svg": 652,
	"./logoIn.svg": 653,
	"./paint.svg": 654,
	"./protection.svg": 655,
	"./quote.png": 656,
	"./repeat.svg": 657,
	"./right.svg": 658,
	"./strategy.svg": 659,
	"./theme.svg": 660,
	"./user.svg": 661,
	"./water-fall.svg": 662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;